const GroupsToPermissions = (provider, groups) => {
  if (!groups || groups.length === 0) {
    // No groups, error of admin on Aws Console when create user without group !
    let error = new Error('The admin must be define one group to  the user !')
    error.code = 'group-not-found'
    throw error
  }
  // let groupKey = groups.map((group) => provider + ':' + group).join(',')

  return Promise.resolve([
  ]) // TODO : Update this
}

export default GroupsToPermissions
